import React, { useEffect, useState } from "react";
import moment from "moment";
import { dateFilterKeys } from "../../../utils/wildCardFilterUtils";
import { dateTimeFinder } from "../../../config/utils";

const DateFilterCalendar = ({ filterDate, onChange, logDateFilterKey = "", className = "" }) => {
    const [localDate, setLocalDate] = useState({ from: "", to: "" });
    const [filterKey, setFilterKey] = useState([]);

    useEffect(() => {
        setLocalDate({
            from: filterDate?.key?.from ?? filterDate?.from ?? "",
            to: filterDate?.key?.to ?? filterDate?.to ?? ""
        });

        setFilterKey(filterDate?.filterKey ?? []);
    }, []);

    const handleDateChange = (key, value) => {
        const updated = {
            ...localDate,
            [key]: value
        };

        setLocalDate(updated);

        // if (updated.from && updated.to && filterKey?.length) {
        //     onChange?.({
        //         filter: {
        //             key: updated,
        //             filters: ["in_between"],
        //             filterKey
        //         }
        //     });
        // }
    };

    const handleClear = () => {
        const reset = { from: "", to: "" };
        setLocalDate(reset);
        setFilterKey([]);

        onChange?.({
            filter: null
        });
    };

    const handleWildcardChange = (value, checked) => {
        let updatedKeys = [...filterKey];

        if (checked) {
            updatedKeys = [value];
        } else {
            updatedKeys = [];
        }

        setFilterKey(updatedKeys);
        const range = value !== "in_between" ? dateTimeFinder(value) : localDate;
        if (!range?.from && !range?.to) return;
        if (!checked) {
            onChange?.({
                filter: null
            });
            return;
        }

        onChange?.({
            filter: {
                key: range,
                filters: ["in_between"],
                filterKey: updatedKeys
            }
        });
    };

    return (
        <div className={`dropdown-menu drop-filtr sub-drop ${className}`.trim()}>
            {/* DATE INPUT */}
            <div className="slct-date-otr">
                <div className="place-holder">
                    <div className="col-md-2 p-0 labl-txt">From</div>
                    <div className="col-md-10 pr-0">
                        <input
                            type="date"
                            value={localDate?.from ? moment(localDate.from).format("YYYY-MM-DD") : ""}
                            onChange={e => handleDateChange("from", e.target.value)}
                        />
                    </div>
                </div>

                <div className="place-holder">
                    <div className="col-md-2 p-0 labl-txt">To</div>
                    <div className="col-md-10 pr-0">
                        <input
                            type="date"
                            value={localDate?.to ? moment(localDate.to).format("YYYY-MM-DD") : ""}
                            onChange={e => {
                                setFilterKey([]);
                                handleDateChange("to", e.target.value);
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="check-box-otr-dte d-flex col-md-12">
                {dateFilterKeys
                    .filter(e => !["next_week", "next_year", "tomorrow", "next_month"]?.includes(e.value))
                    .map((item, i) => (
                        <React.Fragment key={item.value || i}>
                            <div className="col-md-6 p-0">
                                <span className="dropdown-item">
                                    <label className="container-check">
                                        {item.label}

                                        {item.value && (
                                            <>
                                                <input
                                                    type="checkbox"
                                                    checked={filterKey.includes(item.value) || false}
                                                    onChange={e => handleWildcardChange(item.value, e.target.checked)}
                                                />
                                                <span className="checkmark" />
                                            </>
                                        )}
                                    </label>
                                </span>
                            </div>

                            {i % 6 === 1 ? <div className="col-md-12 dropdown-line" /> : null}
                        </React.Fragment>
                    ))}
            </div>

            {/* CLEAR BUTTON */}
            <div className="col-md-12 d-flex justify-content-end mt-2">
                <button type="button" className="btn btn-sm btn-light border" onClick={handleClear}>
                    Clear
                </button>
            </div>
        </div>
    );
};

export default DateFilterCalendar;
